import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import { IMotivoConferencia } from "../../interfaces/IMotivoConferencia";

import EctLogoSimples from '../../../../assets/img/favi-ect.png';


interface Props {

    motivoSelecionado: IMotivoConferencia | null;
    setMotivoSelecionado: (motivo: IMotivoConferencia | null) => void;
    motivosFiltrados: IMotivoConferencia[];
    show: boolean;
    setShow: (show: boolean) => void;

}


const ModalSituacao = ({ motivosFiltrados,
    motivoSelecionado,
    setMotivoSelecionado,
    show,
    setShow }: Props) => {

    const handleClose = () => setShow(false)
    const [motivo, setMotivo] = useState<number>(0)

    const filtrarMotivoSelecionado = (e: any, proximoTipo: string) => {

        let motivoS: IMotivoConferencia[] = [];
        //Entra nesta condicao if somente quando selecionada a opcao Faltantes
        if (e.target.textContent === 'Sim') {

            motivoS = [{
                "id": 100,
                "descricao": "Objeto Faltante",
                "tipo": proximoTipo,
                "motivo": 1
            }];
        } else {
            //Entra aqui na opcao Excluidos
            motivoS = motivosFiltrados.filter(m => m.id === motivo)
        }
        if(motivoS.length > 0){
            setMotivoSelecionado({...motivoS[0], tipo: proximoTipo})
        }else{
            setMotivoSelecionado(null)
        }
        setMotivo(0)
        setShow(false)
    }

    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                    <img src={EctLogoSimples}
                            alt="Logo ECT"
                            className="rounded me-2"
                        />
                        <strong className="me-auto">sroconferencia</strong>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    {
                        motivosFiltrados && motivosFiltrados.length > 0 ?
                            <Form.Select value={motivo} onChange={(e) => { setMotivo(e.target.value ? parseInt(e.target.value) : 0) }} aria-label="Default select example">
                                <option>Selecione um dos motivos</option>
                                {motivosFiltrados.map((m: IMotivoConferencia) => {

                                    return <option key={m.id} value={m.id}>{m.descricao}</option>

                                })
                                }

                            </Form.Select>
                            : <>
                                <span className="d-block mb-3">A situação do(s) objeto(s) selecionado(s) será alterada de Pendente(s) para Faltante(s)</span>

                                <strong>Confirma alteração?</strong>
                            </>


                    }



            </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {motivosFiltrados && motivosFiltrados.length > 0 ? 'Cancelar' : 'Não'}
                    </Button>
                    <Button variant="primary" onClick={(e) => filtrarMotivoSelecionado(e, motivosFiltrados && motivosFiltrados.length > 0 ? 'E' : 'F')}>
                        {motivosFiltrados && motivosFiltrados.length > 0 ? 'Salvar' : 'Sim'}
                    </Button>
                </Modal.Footer>
            </Modal>


        </>
    )
}

export default ModalSituacao